import styled from "styled-components";
import { BodyDefault, HeadLine1 } from "../../../../components/typography/styled";

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  @media screen and (max-width: 768px) {
    width: 100%;
    min-width: 0;
  }
`
export const CreateContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 10px 30px 30px 30px;

  @media screen and (max-width: 768px) {
    flex-direction: column;
    width: 100%;
    min-width: 0;
    padding: 10px 16px 30px;
    box-sizing: border-box;
  }
`
export const TitleBig = styled(HeadLine1)`
  color:${({theme}) => theme.palette[850]};
  margin-top: 20px;
  margin-bottom: 20px;
`
export const FormWrapper = styled.div`
  display:flex;
  flex-direction: column;
  gap:20px;
  max-width: 100%;

  @media screen and (max-width: 768px) {
    width: 100%;

    & > div {
      max-width: 100%;
      flex-wrap: wrap;
      gap: 10px;
    }
  }
`
